import React from "react";
import Card2 from "./Card2";
import { Typography, Grid } from "@mui/material";
import "./Things.css";

function Things() {
  return (
    <div className="things_section">
      <Typography
        variant="h4"
        color={"#fff"}
        align="center"
        sx={{ marginTop: "50px" }}>
        Thigs I love
      </Typography>

      <Grid container align="center">
        <Grid item xs={12} md={4}>
          <Card2 name1="Problem" name2={`Solving ( DSA )`} emoji="💻"></Card2>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card2 name1="Web" name2="Devlopment " emoji="</>"></Card2>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card2 name1="To play with" name2="Bits" emoji="0️⃣"></Card2>
        </Grid>
      </Grid>
    </div>
  );
}

export default Things;
